/**
 * 用户信息管理
 */
import { find, get, includes } from 'lodash-es';

// 与后端getLoginUser接口返回内容一致
// interface User {
//   id: string;
//   account: string;
//   name: string;
//   adminType: number;
//   permissions: string[];
//   phone: string;
//   sex: number;
//   apps: Application[];
//   menus: Menu[];
// }

const MOCK_USER = {
    id: 'NN2x2JiyWhffYK4rMdnZkPXYZbWtSJmW',
    account: 'superAdmin',
    name: '超级管理员',
    adminType: 1,
    permissions: ['auth1', 'auth2'],
    phone: '18020030720',
    sex: 0,
};

let _user = null;
// let _user = MOCK_USER;

export const setUser = (user) => {
    _user = user;
};

export const getUser = () => _user;

export const hasUserInfo = () => _user !== null;

/**
 * 获取用户权限列表
 */
export const getUserAuth = () => {
    const filters = [
      // 'instrument_ana:KLinePage',
    ]
    return get(_user, 'permissions', []).filter((item) => !filters.includes(item));
};

export const getUserMenuAuth = () => {
    return get(_user, 'menus', []);
};

export const userHasMenuAuth = (auth) => {
    return find(getUserMenuAuth(), (menu) => menu.name === auth) !== undefined;
};

export const userHasPermission = (auth) => {
    return includes(getUserAuth(), auth);
};

export const userHasAuth = (auth) => {
    return userHasMenuAuth(auth) || userHasPermission(auth);
};
